import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { RHFTextField } from '../../../../components/hook-form';
import { useFormContext } from 'react-hook-form';

/** Matches the backend ADDITIONAL_FIELD_MAX_LENGTH (TEXT columns). */
const ADDITIONAL_FIELD_MAX_LENGTH = 5000;

const Additional = () => {
  const { setValue, getValues } = useFormContext();

  const clearExternalData = () => {
    const fieldNames = [
      'additional.leftAmslerChart',
      'additional.leftVisualFields',
      'additional.leftIshihara',
      'additional.leftColorVision',
      'additional.leftPinhole',
      'additional.rightAmslerChart',
      'additional.rightVisualFields',
      'additional.rightIshihara',
      'additional.rightColorVision',
      'additional.rightPinhole',
      'additional.leftPupilDilation',
      'additional.rightPupilDilation',
      'additional.leftContrastSensitivity',
      'additional.rightContrastSensitivity',
    ];

    const clearedValues = { ...getValues() };
    fieldNames.forEach((fieldName) => {
      clearedValues[fieldName] = '';
    });

    // Update the form values
    Object.keys(clearedValues).forEach((fieldName) => {
      setValue(fieldName, clearedValues[fieldName]);
    });
  };

  const copyData = () => {
    const leftAmslerChart = getValues('additional.leftAmslerChart');
    const leftVisualFields = getValues('additional.leftVisualFields');
    const leftIshihara = getValues('additional.leftIshihara');
    const leftColorVision = getValues('additional.leftColorVision');
    const leftPinhole = getValues('additional.leftPinhole');
    const leftPupilDilation = getValues('additional.leftPupilDilation');
    const leftContrastSensitivity = getValues(
      'additional.leftContrastSensitivity',
    );

    setValue('additional.rightAmslerChart', leftAmslerChart);
    setValue('additional.rightVisualFields', leftVisualFields);
    setValue('additional.rightIshihara', leftIshihara);
    setValue('additional.rightColorVision', leftColorVision);
    setValue('additional.rightPinhole', leftPinhole);
    setValue('additional.rightPupilDilation', leftPupilDilation);
    setValue('additional.rightContrastSensitivity', leftContrastSensitivity);
  };

  const defaultValues = () => {
    const defaults = {
      amslerChart: 'normal',
      visualFields: 'full',
      ishihara: 'normal',
      colorVision: 'normal',
      pinhole: 'N/A',
      pupilDilation: 'N/A',
      contrastSensitivity: 'normal',
    };

    setValue('additional.leftAmslerChart', defaults.amslerChart);
    setValue('additional.leftVisualFields', defaults.visualFields);
    setValue('additional.leftIshihara', defaults.ishihara);
    setValue('additional.leftColorVision', defaults.colorVision);
    setValue('additional.leftPinhole', defaults.pinhole);
    setValue('additional.rightAmslerChart', defaults.amslerChart);
    setValue('additional.rightVisualFields', defaults.visualFields);
    setValue('additional.rightIshihara', defaults.ishihara);
    setValue('additional.rightColorVision', defaults.colorVision);
    setValue('additional.rightPinhole', defaults.pinhole);
    setValue('additional.leftPupilDilation', defaults.pupilDilation);
    setValue('additional.rightPupilDilation', defaults.pupilDilation);
    setValue(
      'additional.leftContrastSensitivity',
      defaults.contrastSensitivity,
    );
    setValue(
      'additional.rightContrastSensitivity',
      defaults.contrastSensitivity,
    );
  };
  return (
    <>
      <Stack
        direction="row"
        alignItems="right"
        justifyContent="right"
        ml={1}
        mr={1}
        spacing={2}
      >
        <Button variant="contained" onClick={clearExternalData}>
          Clear
        </Button>
        <Button variant="contained" onClick={defaultValues}>
          Default
        </Button>
        <Button variant="contained" onClick={copyData}>
          Copy R to L
        </Button>
      </Stack>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
        p={5}
      >
        <Box
          sx={{
            width: '33.33%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography color={'#637381'} variant="h6" mb={3}>
            Right
          </Typography>
          <RHFTextField
            name="additional.leftAmslerChart"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.leftVisualFields"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.leftIshihara"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.leftColorVision"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.leftPinhole"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.leftPupilDilation"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.leftContrastSensitivity"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
        </Box>
        <Box
          sx={{
            width: '33.33%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography color={'#637381'} variant="h6" mb={3}></Typography>
          <Typography color={'#637381'} variant="h6" mt={3}>
            Amsler Chart
          </Typography>
          <Typography color={'#637381'} variant="h6" mt={3}>
            Visual Fields{' '}
          </Typography>
          <Typography color={'#637381'} variant="h6" mt={3}>
            Ishihara
          </Typography>
          <Typography color={'#637381'} variant="h6" mt={3}>
            Color Vision
          </Typography>
          <Typography color={'#637381'} variant="h6" mt={3}>
            Pinhole
          </Typography>
          <Typography color={'#637381'} variant="h6" mt={3}>
            Pupil Dilation
          </Typography>
          <Typography color={'#637381'} variant="h6" mt={3}>
            Contrast Sensitivity
          </Typography>
        </Box>
        <Box
          sx={{
            width: '33.33%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography color={'#637381'} variant="h6" mb={3}>
            Left
          </Typography>
          <RHFTextField
            name="additional.rightAmslerChart"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.rightVisualFields"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.rightIshihara"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.rightColorVision"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.rightPinhole"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.rightPupilDilation"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
          <RHFTextField
            name="additional.rightContrastSensitivity"
            multiline
            maxRows={4}
            inputProps={{ maxLength: ADDITIONAL_FIELD_MAX_LENGTH }}
            size="small"
            sx={{ width: '90%', marginBottom: '10px' }}
          />
        </Box>
      </Box>
    </>
  );
};

export default Additional;
